import { useContext, useEffect, useState } from 'react';
import { DataContex } from '../../context/DataContext';
import { Container, Col, Row, Table, Button } from 'react-bootstrap';

import { useIncrementFilesDown } from "../../hooks/useIncrementFilesDown";

export const ListadoMateriales = () => {

    const { incrementFilesDown } = useIncrementFilesDown();


    const handleCkickPDF = (file, id = "sinId") => {
      try {
        console.log(id);
        window.open(file);
        incrementFilesDown(id);
      } catch (error) {
        console.error("Error en handleCkickPDF:", error);
      }
    };
  

    const { recursosMapeadosFire } = useContext(DataContex);

    const [recursos, setRecursos] = useState([]);
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {
        const recursosOrdenados = [...recursosMapeadosFire].sort((a, b) =>
            a.title.localeCompare(b.title)
        );
        setRecursos(recursosOrdenados);
    }, [recursosMapeadosFire]);

    useEffect(() => {
        const categoriasUnicas = [...new Set(recursos.map(recurso => recurso.title))];
        setCategorias(categoriasUnicas);
    }, [recursos]);

    return (
        <div>
            <Container>
                <Row>
                    <h1>Listado de Materiales</h1>
                    <h2>Crucigramas, actividades e investigaciones que realizamos para las obras.</h2>
                    <h4>Total: {recursosMapeadosFire.length}</h4>
                    <Col>
                        <h4>Están redactados de manera accesible a los chicos grandes y se pueden descargar gratuitamente.
                            Se encuentran agrupados según las siguientes categorías:
                        </h4>
                        <ul>
                            {categorias.map((categoria) => (
                                <li key={categoria}>{categoria}</li>
                            ))}
                        </ul>
                    </Col>
                    {
                    recursos.length > 0 ?(
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Categoría</th>
                                    <th>Descripción</th>
                                    <th>Tipo</th>
                                    <th>Niveles</th>

                                    <th>Descargas</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recursos.map((recurso) => (
                                    <tr key={recurso.id}>
                                        <td>{recurso.title}</td>
                                        <td>{recurso.description}</td>
                                        <td>{recurso.tipo}</td>
                                        <td>
                                            {recurso.inicial && 'Inicial '}
                                            {recurso.primerCiclo && '1° Ciclo '}
                                            {recurso.segundoCiclo && '2° Ciclo '}
                                            {recurso.tercerCiclo && '3° Ciclo '}
                                            {recurso.secundario && 'Secundario '}
                                        </td>
                                        <td>{recurso.descargas}</td>
                                        <td>
                                            <Button
                                                variant="primary"
                                                href={recurso.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={() => handleCkickPDF(recurso.link, recurso.id ? recurso.id : "sinId")}
                                            >
                                                Ver PDF
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ):(
                        <h4>Cargando...</h4>
                    )                        
                    }
                </Row>
            </Container>
        </div>
    )
}
